<div class="configuration-phone-number" [ngClass]="{'test-mode': isTestMode, 'trial-mode': isFreeTrialMode}">
    <div *ngIf="isTestMode" class="status-badge test">TEST MODE</div>
    <div *ngIf="isFreeTrialMode" class="status-badge trial">{{trialDaysLeft || 0}} {{ (+trialDaysLeft === 1) ? 'Day' :
        'Days' }} Left In Your Free Trial</div>
    <ng-container>
        <div class="phone-number">
            <img src="assets/images/phone.svg" class="phone-icon"
                *ngIf="!agentPhoneNumber && (!hasExpiredPhoneNumber || isReissuingNumberInProgress)">
            <a class="number" *ngIf="agentPhoneNumber" [href]="'tel:' + agentPhoneNumber">
                {{ agentPhoneNumber | phoneNumber}}</a>
            <span *ngIf="!agentPhoneNumber && (!hasExpiredPhoneNumber || isReissuingNumberInProgress)">
                <rosie-loader
                    [config]="{show: true, customLoaderWrapperClass: 'rosie-dark-loader rosie-btn-loader'}"></rosie-loader>
            </span>
            <rosie-button *ngIf="!agentPhoneNumber && hasExpiredPhoneNumber && !isReissuingNumberInProgress"
                [customClass]="'action narrower slimmer text-sm'" [translationKey]="'SUBSCRIPTION.REISSUE_NUMBER'"
                (click)="reissueNumber()"></rosie-button>
        </div>
        <div class="time-usage" *ngIf="(isTestMode || isFreeTrialMode) && !isCreditCardAdded">
            <img src="assets/images/info.svg">
            <span class="time-usage-text">Test calls only</span>
        </div>
        <div class="time-usage d-flex align-items-center" *ngIf="isTrialing && !isTestMode && !isFreeTrialMode">
            <circle-progress [percent]="percentsUsed" [maxPercent]="100"
                [outerStrokeColor]="strokeColor"></circle-progress>
            <span class="time-usage-text">{{
                minutesRemainingFormatted }}
                {{'SUBSCRIPTION.MINUTES_LEFT' | translate}}</span>
            <img src="assets/images/info.svg" [ngbTooltip]="trailTooltip"
                tooltipClass="tooltip-wrapper content-tooltip description-tooltip" positionTarget=".time-usage" />
            <ng-template #trailTooltip>
                <span *ngIf="!isCreditCardAdded"
                    [innerHTML]="'SUBSCRIPTION.MINUTES_USED_TRIAL_DESCRIPTION' | translate:{minutesUsed: minutesUsedFormatted, minutesIncluded: subscriptionData?.minutesIncluded, minutesRemaining: minutesRemaining, billingDate: subscriptionData?.billingDate | dateFormat, overageMinutes: extraMinutes, overageCost: userInformation?.subscription?.overageCost | rosieCurrency }">
                </span>
                <span *ngIf="isCreditCardAdded"
                    [innerHTML]="'SUBSCRIPTION.MINUTES_LEFT_DESCRIPRION' | translate:{value: minutesRemainingFormatted, selectedPlan: selectedPlan, selectedPlanPrice: selectedPlanPrice}">
                </span>
            </ng-template>
        </div>
        <div class="time-usage d-flex align-items-center justify-content-center" *ngIf="isSubscriptionActive">
            <span class="time-usage-text">{{'SUBSCRIPTION.YOUR_ROSIE_NUMBER' | translate}}</span>
        </div>
    </ng-container>
</div>